export const getNodesByIds = (data, ids = []) => {
  const result = [];
  ids.forEach(item => {
    result.push(data[item])
  });
  return result;
};
